module.exports = __webpack_public_path__ + "static/img/nykart-screen1-2x.13fa74f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nykart-screen1-2x.jpg
// module id = 5vNS
// module chunks = 0